import * as TypeGraphQL from "type-graphql";
export var FeatureImportanceAnalysisScalarFieldEnum;
(function (FeatureImportanceAnalysisScalarFieldEnum) {
    FeatureImportanceAnalysisScalarFieldEnum["id"] = "id";
    FeatureImportanceAnalysisScalarFieldEnum["modelVersionId"] = "modelVersionId";
    FeatureImportanceAnalysisScalarFieldEnum["analysisType"] = "analysisType";
    FeatureImportanceAnalysisScalarFieldEnum["featureImportances"] = "featureImportances";
    FeatureImportanceAnalysisScalarFieldEnum["globalImportance"] = "globalImportance";
    FeatureImportanceAnalysisScalarFieldEnum["localImportance"] = "localImportance";
    FeatureImportanceAnalysisScalarFieldEnum["analysisMetadataSampleSize"] = "analysisMetadataSampleSize";
    FeatureImportanceAnalysisScalarFieldEnum["analysisMetadataBaselineAccuracy"] = "analysisMetadataBaselineAccuracy";
    FeatureImportanceAnalysisScalarFieldEnum["analysisMetadataAnalysisDate"] = "analysisMetadataAnalysisDate";
    FeatureImportanceAnalysisScalarFieldEnum["analysisMetadataComputationTime"] = "analysisMetadataComputationTime";
    FeatureImportanceAnalysisScalarFieldEnum["analysisMetadataAnalysisParameters"] = "analysisMetadataAnalysisParameters";
    FeatureImportanceAnalysisScalarFieldEnum["insightsTopFeatures"] = "insightsTopFeatures";
    FeatureImportanceAnalysisScalarFieldEnum["insightsRedundantFeatures"] = "insightsRedundantFeatures";
    FeatureImportanceAnalysisScalarFieldEnum["insightsUnexpectedImportances"] = "insightsUnexpectedImportances";
    FeatureImportanceAnalysisScalarFieldEnum["insightsStabilityScore"] = "insightsStabilityScore";
    FeatureImportanceAnalysisScalarFieldEnum["insightsRecommendations"] = "insightsRecommendations";
    FeatureImportanceAnalysisScalarFieldEnum["createdAt"] = "createdAt";
    FeatureImportanceAnalysisScalarFieldEnum["updatedAt"] = "updatedAt";
})(FeatureImportanceAnalysisScalarFieldEnum || (FeatureImportanceAnalysisScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(FeatureImportanceAnalysisScalarFieldEnum, {
    name: "FeatureImportanceAnalysisScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=FeatureImportanceAnalysisScalarFieldEnum.js.map